import styled, { createGlobalStyle } from 'styled-components';
import {
  AuthFlowColors,
  AuthFlowFont,
} from '../../public/authFlow/authFlow.constants';

/**
 * The time-picker dropdown renders in a body portal, so it can't be reached by
 * the scoped wrapper below. This global rule re-themes ONLY the onboarding
 * picker (via the `onb-time-dropdown` class) from the app's blue to navy —
 * Settings' picker keeps the default theme.
 */
export const STimeDropdownTheme = createGlobalStyle`
  .ant-picker-dropdown.onb-time-dropdown {
    .ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
      background: rgba(26, 58, 92, 0.08) !important;
      color: ${AuthFlowColors.navy} !important;
    }
    .ant-picker-time-panel-cell-inner:hover {
      background: rgba(26, 58, 92, 0.06) !important;
    }
    .ant-picker-ok .ant-btn-primary {
      background: ${AuthFlowColors.navy} !important;
      border-color: ${AuthFlowColors.navy} !important;
    }
    .ant-picker-ok .ant-btn-primary:hover,
    .ant-picker-ok .ant-btn-primary:focus {
      background: ${AuthFlowColors.navyHover} !important;
      border-color: ${AuthFlowColors.navyHover} !important;
    }
  }
`;

/**
 * Re-skins the original WeekDays working-hours editor (antd Tabs + RangePicker)
 * to the ZEST-738 auth-flow theme. `!important` is used to override the legacy
 * STabs colours baked into the reused component.
 */
export const SWorkingHoursField = styled.div`
  font-family: ${AuthFlowFont};

  .ant-tabs-nav {
    margin-bottom: 16px;
  }

  /* Day tabs -> pill look */
  .ant-tabs-tab {
    background: ${AuthFlowColors.pageBg} !important;
    border: 1px solid ${AuthFlowColors.heroStroke} !important;
    border-radius: 8px !important;
  }
  .ant-tabs-tab .tab-inner {
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 8px !important;
    font: 600 13px/40px ${AuthFlowFont};
    color: ${AuthFlowColors.navy};
  }
  /* a day that already has hours set */
  .ant-tabs-tab .tab-inner.filled {
    background: #29b6f6 !important;
    color: ${AuthFlowColors.white} !important;
  }
  /* the currently selected day tab */
  .ant-tabs-tab-active .tab-inner,
  .ant-tabs-tab-active .tab-inner.filled {
    background: ${AuthFlowColors.navy} !important;
    color: ${AuthFlowColors.white} !important;
  }

  /* "Working hours" caption inside each pane */
  .ant-typography {
    display: inline-block;
    margin: 4px 0 8px;
    font: 500 14px/16px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }

  /* Range picker -> 44px new-theme input */
  .ant-picker {
    width: 100%;
    min-height: 44px;
    padding: 8px 12px;
    border-radius: 8px !important;
    border: 1px solid ${AuthFlowColors.cardBorder} !important;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    background: ${AuthFlowColors.white} !important;
    font-family: ${AuthFlowFont};
  }
  .ant-picker:hover,
  .ant-picker-focused {
    border-color: ${AuthFlowColors.navy} !important;
  }
  .ant-picker-input > input {
    font: 400 14px/24px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }
  .ant-picker-input > input::placeholder {
    color: ${AuthFlowColors.placeholder};
  }

  /* "Add new fields" link */
  .ant-btn-link {
    padding-left: 0;
    color: ${AuthFlowColors.link};
    font: 600 14px/16px ${AuthFlowFont};
  }
  .ant-btn-link[disabled],
  .ant-btn-link[disabled]:hover {
    color: ${AuthFlowColors.placeholder};
  }
`;
